import { useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { dashboardService } from '../../services/dashboard';

export default function AutoTopUpModal() {
  const navigate = useNavigate();
  const { autoTopUp: initial, loadBilling } = useOutletContext();
  const [autoTopUp, setAutoTopUp] = useState(initial);
  const [saving, setSaving] = useState(false);

  const close = () => navigate('/billing/');

  const save = () => {
    setSaving(true);
    dashboardService.billingAutoTopUp(
      autoTopUp,
      () => {
        setSaving(false);
        loadBilling();
        close();
      },
      () => setSaving(false),
    );
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-2xl bg-theme-main border border-theme-secondary p-6 shadow-lg">
        <h2 className="text-lg font-medium mb-4">Auto top-up</h2>
        <p className="text-sm opacity-60 mb-4">
          Automatically add credits when your balance drops below a threshold.
        </p>
        <div className="space-y-3 mb-6">
          <label className="flex items-center gap-3 text-sm">
            <input
              type="checkbox"
              checked={autoTopUp.enabled}
              onChange={(e) => setAutoTopUp((s) => ({ ...s, enabled: e.target.checked }))}
              className="rounded"
            />
            Enable auto top-up
          </label>
          <label className="block text-sm">
            <span className="opacity-60">Threshold ($)</span>
            <input
              type="number"
              min="1"
              value={autoTopUp.threshold_usd}
              onChange={(e) => setAutoTopUp((s) => ({ ...s, threshold_usd: parseFloat(e.target.value) || 0 }))}
              className="w-full mt-1 rounded-lg border border-theme-secondary bg-theme-main px-3 py-2"
            />
          </label>
          <label className="block text-sm">
            <span className="opacity-60">Top-up amount ($)</span>
            <input
              type="number"
              min="5"
              value={autoTopUp.amount_usd}
              onChange={(e) => setAutoTopUp((s) => ({ ...s, amount_usd: parseFloat(e.target.value) || 0 }))}
              className="w-full mt-1 rounded-lg border border-theme-secondary bg-theme-main px-3 py-2"
            />
          </label>
        </div>
        <div className="flex justify-end gap-3">
          <button type="button" onClick={close} className="px-4 py-2 rounded-lg border border-theme-secondary text-sm">
            Cancel
          </button>
          <button
            type="button"
            onClick={save}
            disabled={saving}
            className="px-4 py-2 rounded-lg bg-theme-primary text-theme-button text-sm font-medium disabled:opacity-40"
          >
            {saving ? 'Saving…' : 'Save settings'}
          </button>
        </div>
      </div>
    </div>
  );
}
